<template>
  <div class="container mt-4">
    <!-- Header -->
<div class="d-flex justify-content-between align-items-center flex-wrap gap-3 bg-white p-3 rounded border mb-4">
    <div class="d-flex align-items-center gap-3 flex-wrap">
        <h4 class="mb-0 fw-semibold">{{ profile.title || 'Work Order Request' }}</h4>
        <span class="badge bg-light text-secondary fw-normal px-3 py-1">#{{ profile.external_id || 'N/A' }}</span>
    </div>
    <div class="d-flex gap-2">
        <button class="btn btn-outline-secondary btn-sm" @click="$router.back()">
        <i class="fas fa-arrow-left"></i> Back
        </button>
        <!-- <button class="btn btn-primary btn-sm">
        <i class="fas fa-edit"></i> Edit
        </button> -->
    </div>
</div>

    <!-- Loading -->
    <LoadingBar v-if="loading" message="Loading Request Details..." />

    <!-- Profile Content -->
    <div v-else class="bg-white rounded shadow-sm p-4">
      <div class="row">
        <!-- Left Column -->
        <div class="col-md-6">
          <div class="info-group">
            <div class="info-heading">Request Title / Issue</div>
            <div class="info-value">{{ profile.title || 'N/A' }}</div>
          </div>

          <div class="info-group">
            <div class="info-heading">Issue Related To</div>
            <div class="info-value">
              {{ profile.issue_related_to !== 'other' ? profile.issue_related_to : profile.other_issue_detail || 'N/A' }}
            </div>
          </div>

          <div class="info-group">
            <div class="info-heading">Priority</div>
            <div class="info-value">
              <span :class="[getPriorityClass(profile.priority), 'text-capitalize']">
                {{ profile.priority || 'N/A' }}
              </span>
            </div>
          </div>

          <div class="info-group">
            <div class="info-heading">Status</div>
            <div class="info-value">
              <span :class="getStatusClass(profile.status)">
                {{ profile.status || 'Pending' }}
              </span>
            </div>
          </div>
        </div>

        <!-- Right Column -->
        <div class="col-md-6">
          <div class="info-group">
            <div class="info-heading">Location</div>
            <div class="info-value">{{ profile.get_location?.name || profile.location || 'N/A' }}</div>
          </div>

          <div class="info-group">
            <div class="info-heading">Asset</div>
            <div class="info-value">{{ profile.get_asset?.name || profile.asset || 'N/A' }}</div>
          </div>

          <div class="info-group">
            <div class="info-heading">Requested By</div>
            <div class="info-value">{{ profile.get_requester?.first_name || profile.requested_by || 'N/A' }}</div>
          </div>

          <div class="info-group">
            <div class="info-heading">Requested At</div>
            <div class="info-value">{{ formatDate(profile.created_at) }}</div>
          </div>
        </div>
      </div>

      <!-- Description Full -->
      <div class="mt-3 pt-3 border-top">
        <div class="info-heading">Description</div>
        <div class="info-value" style="white-space: pre-wrap;">{{ profile.description || 'No description provided.' }}</div>
      </div>

      <!-- Attachments -->
      <div v-if="profile.files && profile.files.length > 0" class="mt-3 pt-3 border-top">
        <div class="info-heading">Attachments</div>
        <div class="d-flex flex-wrap gap-2 mt-2">
          <a v-for="(file, index) in profile.files" :key="index" :href="$backend_domain + file.path" target="_blank" class="attachment-link">
            <i class="fas fa-paperclip"></i> {{ file.name || `File ${index + 1}` }}
          </a>
        </div>
      </div>

      <!-- <div class="mt-3 pt-3 border-top">
        <div class="info-heading">Work Orders Against This Request</div>
        <div class="info-value" style="white-space: pre-wrap;">
            <span class='text-muted'>No work orders found for this request.</span>

        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import LoadingBar from '@/components/utils/LoadingBar.vue'

export default {
  name: 'WoRequestProfile',
  components: {
    LoadingBar
  },
  data() {
    return {
      profile: {},
      loading: false
    }
  },
  mounted() {
    this.fetchProfile()
  },
  methods: {
    async fetchProfile() {
      this.loading = true

      const result = await form_api_submit({
        url: `wo/request/profile/${this.$route.params.id}`,
        method: 'GET',
        show_success_toast: false,
        show_error_toast: true
      })

      if (result.success) {
        this.profile = result.data
      }

      this.loading = false
    },

    formatDate(date) {
      if (!date) return 'N/A'
      return new Date(date).toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    getPriorityClass(priority) {
      const classes = {
        low: 'badge bg-info',
        medium: 'badge bg-warning',
        high: 'badge bg-danger'
      }
      return classes[priority] || 'badge bg-secondary'
    },

    getStatusClass(status) {
      const classes = {
        pending: 'badge bg-warning',
        in_progress: 'badge bg-primary',
        completed: 'badge bg-success',
        rejected: 'badge bg-danger'
      }
      return classes[status?.toLowerCase()] || 'badge bg-secondary'
    }
  }
}
</script>

<style scoped>
.info-group {
  margin-bottom: 18px;
}



.attachment-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  font-size: 13px;
  color: #0d6efd;
  text-decoration: none;
  transition: all 0.2s;
}

.attachment-link:hover {
  background: #e9ecef;
  text-decoration: none;
}
</style>